import React, { useContext, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MoreIcon from "@material-ui/icons/MoreVert";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import LanguageSwitcher from "../../LanguageSwitcher";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import SearchBar from "../../SearchBar";
import useStyles from "./AppHeader.style";
import HeaderMessages from "../../HeaderMessages";
import Notifications from "../../Notifications";
import AppLogo from "../../../../shared/components/AppLogo";
import { toggleNavCollapsed, useLayoutActionsContext } from "../LayoutContextProvider";
import { ExitToApp } from "@material-ui/icons";
import { setAuthToken } from "@crema/services/ApiConfig";
import { Button, Tooltip } from "@material-ui/core";
import IntlMessages from "@crema/utility/IntlMessages";
import AppContextPropsType from "types/AppContextPropsType";
import { AppContext } from "@crema";
import AppLogOut from "../../../../modules/auth/AppLogOut";
import HeaderTask from "@crema/core/HeaderTask";
import HeaderUrgentTask from "@crema/core/HeaderUrgentTask";

interface AppHeaderProps { }


const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();

  const dispatch = useLayoutActionsContext()!;

  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = useState<null | HTMLElement>(null);
  const { themeMode, updateAuthUser } = useContext<AppContextPropsType>(AppContext);
  const onUserSignout = () => {
    //logout API goes Here
    updateAuthUser(null);
    setAuthToken(null);
  };
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMobileMenuOpen(event: React.MouseEvent<HTMLElement>) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderUrgentTask />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderTask />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderMessages />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <Notifications />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <IconButton
          aria-label='show more'
          aria-controls={mobileMenuId}
          aria-haspopup='true'
          color='inherit' onClick={onUserSignout}>
          <ExitToApp fontSize="default" style={{ width: '50px' }} />
          <span style={{ fontSize: '16px', fontFamily: 'Roboto-Regular' }}>Logout</span>
        </IconButton>
      </MenuItem>
      {/* <LanguageSwitcher /> */}
    </Menu>
  );

  return (
    <>
      <AppLogOut>
        <AppBar color='inherit' className={clsx(classes.appBar, 'app-bar')}>
          <Toolbar className={classes.appToolbar}>
            <IconButton
              edge='start'
              className={classes.menuButton}
              color='inherit'
              aria-label='open drawer'
              onClick={() => dispatch(toggleNavCollapsed())}>
              <MenuIcon className={classes.menuIcon} />
            </IconButton>

            <AppLogo />
            <Box className={classes.grow} />
            {/* <SearchBar borderLight placeholder='Search…' /> */}
            <Box className={classes.sectionDesktop}>
              {/* <LanguageSwitcher /> */}
              <HeaderUrgentTask />
              <HeaderTask />
              <HeaderMessages />
              <Notifications />
              <Tooltip title={<IntlMessages id='header.tooltip.logout' />}>
                <Button className="logoutBtn" variant="outlined" onClick={onUserSignout} aria-controls={mobileMenuId} startIcon={<ExitToApp />}>
                  Logout
                </Button>
              </Tooltip>
            </Box>
            <Box className={classes.sectionMobile}>
              <IconButton
                aria-label='show more'
                aria-controls={mobileMenuId}
                aria-haspopup='true'
                onClick={handleMobileMenuOpen}
                color='inherit'>
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
      </AppLogOut>
    </>
  );
};
export default AppHeader;


